export {setupInterceptors} from './interceptors'



// WEBPACK FOOTER //
// ./src/services/api/index.js